import { CachedItem } from "@lib-shared/lib";
import { Key } from "core/constants";
import { getErrorMessage, logApiError } from "core/lib";
import { OnPopulate } from "core/lib/self-service.controller";
import { AmountToPayService } from "core/services/cef";
import { CustomerAccountsResponse, CustomerAccountsResponseWrapper } from "core/services/cef/amount-to-pay.service";
import { AmountToPay } from "core/types/business-details";
import AmountToPayStore, { hasRecentPaymentBeenMade } from "./amount-to-pay.store";
import PaymentsStore from "./payments.store";

class AmountToPayStoreManager {
    store: AmountToPayStore;

    private _cache = new CachedItem(Key.amountToPay);

    constructor(store: AmountToPayStore) {
        this.store = store;
    }

    reset() {
        console.log("Resetting");
        this.store.reset();
        this._cache.clear();
    }

    private processAmountToPay = (amount: AmountToPay) => {
        //Payment might have reflected in amount to pay api before or after user got redirected back to dashboard
        //Amount has updated or is zero
        if (hasRecentPaymentBeenMade() &&
            (amount.value === 0 || (this.store.amountToPay && amount.value !== this.store.amountToPay.value))) {
            PaymentsStore.recentPayment.clear();
        }

        this.store.updateAmountToPay(amount);
        this.store.updateIsLoading(false);
    };

    private handleAmountToPayReponse = (response: CustomerAccountsResponse) => {
        const data = new CustomerAccountsResponseWrapper(response);

        const amount = data.toAmountToPay();

        console.log(`Setting amount to pay cache ${Key.amountToPay}`);
        this._cache.set(amount);

        this.processAmountToPay(amount);
    };

    populateAsync = async (onPopulate: OnPopulate | undefined = undefined) => {
        if (this.store.isLoading) {
            return;
        }

        this.store.updateIsLoading(true);
        this.store.updateHasError(false);

        if (this._cache.isCached) {
            const cachedValue = this._cache.value;
            this.store.updateAmountToPay(cachedValue);
            this.store.updateIsLoading(false);
            return;
        }

        try {
            console.log("Fetching amount to pay");
            const response = await new AmountToPayService().getCustomerAccounts();
            this.handleAmountToPayReponse(response?.data);
        }
        catch (error) {
            logApiError(error);

            const firstError = getErrorMessage(error);

            this.store.updateHasError(true, firstError);
            this.store.updateIsLoading(false);

            if (onPopulate?.error) {
                onPopulate.error(error);
            }
        }
    };
}

export default AmountToPayStoreManager;
